module.exports = __webpack_public_path__ + "media/stylesheets/images/media/user_way_circle-051a96ed4054b3c00c398e7fe357c18d.png";